
<template>
  <div class="title-mb">
    <div class="title-foot1-mb">
      <Row :gutter="56" justify="center">
        <Col span="8" class="title-foot1-col">
          <div class="score-mb">
            <div class="pf-mb" >
              <div class="row1-mb font1-mb" >{{ score.creditRatingScore }}</div>
              <div class="trapezoid-mb t-bg1-mb"></div>
            </div>
            <div class="row2-mb bg1-mb" >信用风险评分</div>
<!--            <div class="row3-mb" >评分越高，客户信用越好，35分以下建议拒绝 35-45分慎重评估，45-70分综合评估 70以上建议通过。</div>-->
          </div>
        </Col>
        <Col span="8">
          <div class="score-mb">
            <div class="pf-mb" >
              <div class="row1-mb font2-mb" >{{ score.consumptionCapacityScore }}</div>
              <div class="trapezoid-mb t-bg2-mb"></div>
            </div>
            <div class="row2-mb bg2-mb" >还款能力评分</div>
<!--            <div class="row3-mb" >评分依据收消费资产等计算，评分越高，还款能力越强依据客户购买车价综合评估。</div>-->
          </div>
        </Col>
        <Col span="8">
          <div class="score-mb">
            <div class="pf-mb" >
              <div class="row1-mb font3-mb" >{{ homeStat.hitRiskListNum }}</div>
              <div class="trapezoid-mb t-bg3-mb"></div>
            </div>
            <div class="row2-mb bg3-mb" >风险命中数量</div>
<!--            <div class="row3-mb risk-detail" v-if="homeStat && homeStat.riskDetailList && homeStat.riskDetailList.length > 0">-->
<!--              <p v-for="(item, index) in homeStat.riskDetailList" :key="index">-->
<!--                {{item}}<br>-->
<!--              </p>-->
<!--            </div>-->
          </div>
        </Col>
      </Row>
    </div>
    <div class="title-foot2-mb">
      <Row  justify="center">
        <Col span="6" >
          <div class="total-bill-mb" style="color:#1242CD;">
            <div class="tb-font-mb">汇总支出</div>
            <div class="tb-foot-mb">
              <div class="tb-ty-mb tb-ty-bg1-mb">
              </div>
              <div class="tb-num-mb">
                <span style="white-space:nowrap;"><span class="wan-mb">&#9650;</span><span v-if="homeStat.payout.hzPayout">{{formattedMoney( homeStat.payout.hzPayout.money) }}</span><span v-else>0.00</span><span class="wan-mb">万</span></span>
              </div>
            </div>
          </div>
        </Col>
        <Col span="6">
          <div class="total-bill-mb" style="color:#4422D1;">
            <div class="tb-font-mb">汇总收入</div>
            <div class="tb-foot-mb">
              <div class="tb-ty-mb tb-ty-bg2-mb">
              </div>
              <div class="tb-num-mb">
                <span style="white-space:nowrap;"><span class="wan-mb">&#9650;</span><span v-if="homeStat.incoming.hzIncoming">{{formattedMoney( homeStat.incoming.hzIncoming.money) }}</span><span v-else>0.00</span><span class="wan-mb">万</span></span>
              </div>
            </div>
          </div>
        </Col>
        <Col span="6">
          <div class="total-bill-mb" style="color: #F31F1C;">
            <div class="tb-font-mb">转账支出</div>
            <div class="tb-foot-mb">
              <div class="tb-ty-mb tb-ty-bg3-mb">
              </div>
              <div class="tb-num-mb">
                <span style="white-space:nowrap;"><span class="wan-mb">&#9650;</span><span v-if="homeStat.payout.transfer">{{ formattedMoney(homeStat.payout.transfer.money) }}</span><span  v-else>0.00</span><span class="wan-mb">万</span></span>
              </div>
            </div>
          </div>
        </Col>
        <Col span="6">
          <div class="total-bill-mb" style="color: #00D376;">
            <div class="tb-font-mb">转账支出</div>
            <div class="tb-foot-mb">
              <div class="tb-ty-mb tb-ty-bg4-mb">
              </div>
              <div class="tb-num-mb">
                <span style="white-space:nowrap;"><span class="wan-mb">&#9650;</span><span v-if="homeStat.incoming.transfer">{{formattedMoney( homeStat.incoming.transfer.money) }}</span><span v-else>0.00</span><span class="wan-mb">万</span></span>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
export default {
  name: 'content-title',
  props: {
    dataMap: Object,
    homeStat: Object,
    score: Object
  },
  data () {
    return {
    }
  },
  mounted: function () {
    this.setData(this.$parent.dataMap, this.$parent.homeStat, this.$parent.score)
  },
  methods: {
    setData (dataMap, homeStat, score) {
      this.dataMap = dataMap
      this.homeStat = homeStat
      this.score = score
    },
    formattedMoney (value) {
      if (!value) return '0.00'
      const numberInTenThousand = value / 10000
      const roundedNumber = Math.round(numberInTenThousand * 100) / 100
      return roundedNumber.toFixed(2)
    }
  }
}
</script>
<style>
.title-mb {
  margin-bottom: 10pt;
}
.title-foot1-mb {
  margin-top: 8pt;
  margin-left: 10px;
  margin-right: 10px;
}
.title-foot1-col {}
.score-mb {
  width: 100%;
}
.pf-mb {
  position:relative;
  width: 100%;
  height: 60pt;
}
.row1-mb {
  width: 100%;
  font-size: 37pt;
  font-weight: bold;
  font-family: MicrosoftYaHei;
  text-align: center;
  position: absolute;
  bottom: 0;
  z-index: 2;
}
.font1-mb {
  color: #1242CD;
  background-image: url(../../../../assets/images/content-v4/title/xyfxpf.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.font2-mb {
  color: #4422D1;
  background-image: url(../../../../assets/images/content-v4/title/hknlpf.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.font3-mb {
  color: #F31F1C;
  background-image: url(../../../../assets/images/content-v4/title/fxmzsl.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.trapezoid-mb {
  position: absolute;
  width: 100%;
  bottom: 0;
  z-index: 1;
  aspect-ratio: 50 / 3;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.t-bg1-mb {
  background-image: url(../../../../assets/images/content-v4/title/blue-bg.png);
}
.t-bg2-mb {
  background-image: url(../../../../assets/images/content-v4/title/purple-bg.png);
}
.t-bg3-mb {
  background-image: url(../../../../assets/images/content-v4/title/red-bg.png);
}
.row2-mb {
  width: 100%;
  height: 23pt;
  font-family: MicrosoftYaHei;
  color: #FFFFFF;
  font-weight: Bold;
  font-size: 10pt;
  line-height: 23pt;
  text-align: center;
}
.bg1-mb {
  background: #1242CD;
}
.bg2-mb{
  background: #4422D1;
}
.bg3-mb {
  background: #F31F1C;
}
.title-foot2-mb {
  margin: 2% 2% 0 2%;
}
.total-bill-mb {
  text-align:center;
  margin-left: 20%;
  margin-right: 20%;
}
.tb-font-mb {
  white-space:nowrap;
  //margin-top: 5pt;
  margin: auto;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 10pt;
}
.tb-foot-mb {
  margin-top: 15pt;
  width: 100%;
  height: 35pt;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tb-ty-mb {
  width: 100%;
  height: 36pt;
  position: absolute;
}
.tb-ty-bg1-mb {
  background: url(../../../../assets/images/content-v4/title/ty1.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.tb-ty-bg2-mb {
  background: url(../../../../assets/images/content-v4/title/ty2.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.tb-ty-bg3-mb {
  background: url(../../../../assets/images/content-v4/title/ty3.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.tb-ty-bg4-mb {
  background: url(../../../../assets/images/content-v4/title/ty4.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.tb-num-mb {
  font-size: 14pt;
  font-weight: bold;
  text-align: center;
  margin-bottom: 50%;
}
.num-mb {
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 12pt;
}
.wan-mb {
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 10pt;
  margin-top: 4px;
}
.triangle-mb {
  font-size: 8pt;
  margin-top: 8px;
}
</style>
